import { useMissionsTranslation } from '../../../../../ui/hooks';
import { Button, Typography } from '@mui/material';
import React from 'react';
export const ParticipantShiftsTableHeader = ({ onClick, totalShifts, selectedShifts, children, }) => {
    const { t } = useMissionsTranslation();
    return (React.createElement(React.Fragment, null,
        selectedShifts.length > 0 && (React.createElement(Typography, { variant: 'subtitle2', sx: { display: 'inline', ml: 1, whiteSpace: 'nowrap' } }, t('common.selectedCount', { count: selectedShifts.length }))),
        !!totalShifts && (React.createElement(Button, { sx: {
                width: { xs: '100%', md: 'auto' },
            }, variant: 'text', onClick: onClick, "data-test": 'select-unselect-all-button' }, selectedShifts.length === totalShifts ? t('common.unselectAll') : t('common.selectAll'))),
        children));
};
